// @ts-ignore — formiojs v4 ships without first-class TS types
import { Components } from 'formiojs';
import { createRoot, type Root } from 'react-dom/client';
import TakePicture from './TakePicture';
import { takePictureSettings } from './TakePicture.settings';

const Field = Components.components.field;

export default class TakePictureComp extends Field {
    root: Root | null = null;

    static schema(...extend: any[]) {
        return Field.schema({
            type: 'takepicture',
            label: 'Camera',
            key: 'camera',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Camera',
            group: 'custom',
            icon: 'camera',
            weight: 70,
            documentation: '/userguide/#camera',
            schema: TakePictureComp.schema(),
        };
    }

    static editForm = () => {
        return takePictureSettings;
    }

    get defaultSchema() {
        return TakePictureComp.schema();
    }

    renderReact(element: HTMLElement) {
        if (!this.root) {
            this.root = createRoot(element);
        }

        this.root.render(
            <TakePicture
                component={this.component}
                value={this.dataValue}
                disabled={this.component.disabled}
                onChange={(newValue: any) => {
                    this.updateValue(newValue);
                }}
            />
        );
    }

    attach(element: HTMLElement) {
        const ret = super.attach(element);

        // Remove any stale container + React root before re-mounting.
        // FormIO can call attach() again after a save without calling detach()
        // first, which would create a second React root on the same node.
        const old = element.querySelector('.takepicture-react-container');
        if (old) {
            old.remove();
            if (this.root) {
                this.root.unmount();
                this.root = null;
            }
        }

        const container = document.createElement('div');
        container.className = 'takepicture-react-container';
        element.appendChild(container);
        this.renderReact(container);
        return ret;
    }

    detach() {
        if (this.root) {
            this.root.unmount();
            this.root = null;
        }
        return super.detach();
    }
}
